import styled from '@emotion/styled';
import { Text, Stack } from '@pairy/pds-react';

export const Wrapper = styled.div`
  width: 100%;
  height: 50vh;
  max-height: 650px;
`;

export const StackAddedClientsWrapper = styled(Stack)`
  max-height: calc(100% - 41px);
  overflow-y: auto;

  &.empty {
    height: calc(100% - 41px);
  }
`;

export const EmptyText = styled(Text)`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
`;
